import './handlers';
import './subs';

import reframe from 'nike-re-framejs';
import { getUrl } from '@/common/oldMobile';
import axios from 'axios';
import { catcher } from '@/_http/utils';
import { onServerInfo } from '@/server/handlers';

export function scheduleVersionChecking(db) {
    setInterval(serverInfoRequest, 60000);
    serverInfoRequest();
    return db;
}

export const serverInfoRequest = function() {
    if (reframe.appDb.peekValue().getIn(['account', 'loginInProgress'])) {
        // console.log('serverInfoRequest skipped');
        return;
    }
    axios
        .get(getUrl('SERVER_INFO'))
        .then(data => reframe.dispatch(onServerInfo(data)))
        .catch(catcher.swallow);
};
